import { useState } from "react";
import { Copy, DeviceMobile } from "@phosphor-icons/react";
import { toast } from "sonner";
import { API } from "@/lib/site";

export const UpdateApiCard = () => {
  const [code, setCode] = useState("");
  const [result, setResult] = useState(null);
  const endpoint = `${API}/apk/update-check?version_code=`;

  const test = async (e) => {
    e.preventDefault();
    try {
      const r = await fetch(`${endpoint}${encodeURIComponent(code)}&t=${Date.now()}`, { cache: "no-store" });
      setResult(await r.json());
    } catch {
      toast.error("Update check failed");
    }
  };

  const copy = () => navigator.clipboard?.writeText(`${endpoint}<VERSION_CODE>`).then(() => toast.success("Endpoint copied"));

  return (
    <section className="glass rounded-3xl p-5 sm:p-7 space-y-4 mt-6" aria-labelledby="update-api-heading" data-testid="update-api-card">
      <h2 id="update-api-heading" className="font-display text-xl font-bold flex items-center gap-2"><DeviceMobile size={20} className="text-[#00BFFF]" aria-hidden="true" /> In-app update check</h2>
      <p className="text-sm text-slate-400 leading-relaxed">Your Android app calls this URL on launch with its own version code. It returns whether an update is available, whether it is forced, and the download link.</p>
      <div className="flex items-stretch gap-2">
        <code className="flex-1 min-w-0 font-mono-alt text-[11px] text-slate-300 break-all p-3 rounded-lg" style={{ background: "rgba(0,0,0,.35)", border: "1px solid rgba(255,255,255,.06)" }} data-testid="update-api-endpoint">GET {endpoint}&lt;VERSION_CODE&gt;</code>
        <button type="button" onClick={copy} className="btn-ghost !px-3 !rounded-lg" aria-label="Copy endpoint" data-testid="update-api-copy"><Copy size={16} aria-hidden="true" /></button>
      </div>
      <form onSubmit={test} className="flex gap-2">
        <label htmlFor="uc-code" className="sr-only">App version code</label>
        <input id="uc-code" type="number" min="0" required placeholder="App version code, e.g. 1" className="field flex-1 min-w-0" value={code} onChange={(e) => setCode(e.target.value)} data-testid="update-test-input" />
        <button type="submit" className="btn-primary !min-h-[48px] !px-5 text-sm shrink-0" data-testid="update-test-btn">Test</button>
      </form>
      {result && (
        <div data-testid="update-test-result">
          <p className={`text-sm font-semibold ${result.force_update ? "text-red-300" : result.update_available ? "text-[#7DDCFF]" : "text-emerald-300"}`} data-testid="update-test-message">{result.message}</p>
          <pre className="mt-2 font-mono-alt text-[11px] text-slate-400 whitespace-pre-wrap break-all p-3 rounded-lg max-h-64 overflow-auto" style={{ background: "rgba(0,0,0,.35)" }}>{JSON.stringify(result, null, 2)}</pre>
        </div>
      )}
    </section>
  );
};
